import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface AccountLinkRow {
  id: number;
  guid: string;
  candidateId: number;
  concernId: number;
  lastToken: string | null;
  expirationTime: string | null;
  email: string | null;
  provider: string | null;
}

export interface SearchAccountLinksResponse extends BackendResponse {
  items: AccountLinkRow[];
}

export interface SearchAccountLinksParams extends NextApiParams {
  q: string;
  max?: number;
}

export const searchAccountLinks = withNextApi<
  SearchAccountLinksResponse,
  SearchAccountLinksParams
>("/auth/SearchAccountLinks", { method: "GET" });
